export const SWITCH_LABEL_SPACING = 0.75;
export const SWITCH_INPUT_WIDTH = 40;
export const SWITCH_INPUT_HEIGHT = 20;
